import React from 'react';
import { GoogleProductProps } from '../types/layout/LayoutTypes';

const GoogleProductData: React.FC<GoogleProductProps> = (props) => {
  const { name, image, description, sku, productUrl } = props;

  return (
    <div data-testid="googleProductContainer">
      <div itemType="http://schema.org/Product" itemScope>
        <meta itemProp="name" content={name} data-testid="itemName" />
        <link itemProp="image" href={image} data-testid="image" />
        <meta itemProp="description" content={description} data-testid="itemDescription" />
        <div itemProp="offers" itemType="http://schema.org/Offer" itemScope>
          <link itemProp="url" href={productUrl} data-testid="itemUrl" />
          <meta itemProp="availability" content="https://schema.org/InStock" />
          <meta itemProp="sku" content={sku} data-testid="itemSku" />
          <div itemProp="seller" itemType="http://schema.org/Organization" itemScope>
            <meta itemProp="name" content="actionvfx.com" data-testid="sellerUrl" />
          </div>
        </div>
        <div itemProp="brand" itemType="http://schema.org/Brand" itemScope>
          <meta itemProp="name" content="ActionVFX" data-testid="brandName" />
        </div>
      </div>
    </div>
  );
};

export default GoogleProductData;
